module.exports = __webpack_public_path__ + "media/images/gallery/constellations/canis_minor/cmi_vis-edc6508d2da772ca9c086e63dbff3088.jpg";